import { BaseCommandProvider } from "common/app/command-palette/providers/base-provider";
import { GlobalSearchModule } from "common/app/command-palette/providers/global-search/module";
import { Command, RenderModuleProps } from "common/app/command-palette/types";

export class GlobalSearchProvider extends BaseCommandProvider {
  isModuleProvider() {
    return true;
  }

  getCommands(): Command[] {
    return [
      {
        id: "global-search",
        label: _("Go to Record"),
        icon: "fa-search",
        isModule: true,
        onClick: () => this.setModuleRenderer(this.renderModule),
        category: "navigation",
      },
    ];
  }

  renderModule = (props: RenderModuleProps) => {
    return <GlobalSearchModule {...props} />;
  };
}
